import {Component} from '@angular/core';

@Component({
  selector: 'app-circle-online-icon',
  templateUrl: './circle-online-icon.component.html'
})
export class CircleOnlineIconComponent {
}
